;(function($, undefined){
    "use strict";

    var rnn = window.rnn, log, forms, Form, Field;


    function initForms(){

        function ImageForm(options){
            this.base.apply(this, arguments);
        }

        ImageForm.prototype = Object.create(Form.prototype);
        ImageForm.prototype.type = "image";
        ImageForm.prototype.constructor = ImageForm;
        ImageForm.prototype.action = rnn.site.ugcURL;
        ImageForm.prototype.validateReturn = function(data, success, error){
            data = $.parseJSON(data);
            if(!data){
                error({});
            }
            data.result === "success" ? success(data) : error(data);
        };
        ImageForm.prototype.create = function(){
            var form = this.base.prototype.create.apply(this, arguments),
                leftColumn = $($.el.div({'class':'leftColumn'})),
                rightColumn = $($.el.div({'class':'rightColumn'}));

            // Register fields with the form
            form.registerField({name: 'terms_and_conditions', title: 'Terms and conditions', type:'checkbox', label:
                'I certify that I have the right to distribute these photos and I agree with the ',
                append: $.el.a({href:rnn.site.termsUrl}, 'Terms and Conditions.')
            });
            form.registerField(new rnn.modules.tags.TagsSelector({url: rnn.site.tagsURL, name:'tags', placeholder:'Add a tag', title: 'Tags', multiSelect: true, element: 'select'}));
            var imageField = rnn.modules.imageUpload.addImageFieldsTo(form, {name: 'image', title: 'Image Upload'}, {name: 'caption', title: 'Image Caption'});

            // Form context
            form.registerField(new rnn.modules.contentContext.ContentContext(), true);

            // ImageForm specific data
            form.registerField({name: 'form_type', type: 'hidden', value: 'ImageForm'}, true);

            leftColumn.append(
                imageField
            );

            rightColumn.append(
                form.fields.tags.element,
                form.fields.terms_and_conditions.element
            );

            // Add events, and append elements to the forms element
            $(form.element).addClass('imageForm')
            .append(
                $.el.p(form.intro),
                leftColumn,
                rightColumn
            );

            return this;
        };

        // Expose the constructor on the module.
        rnn.modules.ugc2.ImageForm = ImageForm;
    }


    // Initialise Notices
    function initUgcImages() {
        log = rnn.logging.log;
        forms = rnn.modules.forms;
        Form = forms.Form;
        Field = forms.Field;

        initForms();
    }

    rnn.modules.register('ugcImages', {
        init: initUgcImages
    });

}(jQuery));
